<template>
  <div class="vertical-center">
    <div class="select space-r-1">
      <select
        class="form-control inline"
        v-model.number="year"
        @change="onChange"
      >
        <option :value="0"></option>
        <option
          v-for="y in years"
          :value="y"
          :key="`year-${y}`"
        >{{ y }}年</option>
      </select>
    </div>
    <div class="select space-r-1">
      <select
        class="form-control inline"
        v-model.number="month"
        @change="onChange"
      >
        <option :value="0"></option>
        <option
          v-for="m in 12"
          :value="m"
          :key="`month-${m}`"
        >{{ m }}月</option>
      </select>
    </div>
    <div class="select">
      <select
        class="form-control inline"
        v-model.number="date"
        @change="emit"
      >
        <option :value="0"></option>
        <option
          v-for="d in days"
          :value="d"
          :key="`day-${d}`"
        >{{ d }}日</option>
      </select>
    </div>
  </div>
</template>

<script>
import { range } from '@/utils/form'

export default {
  props: {
    value: {
      type: String,
      required: true,
      validator(value) {
        if (value === '') {
          return true
        }
        return /[0-9]{4}-[0-9]{2}-[0-9]{2}/.test(value)
      }
    },
    years: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      year: 0,
      month: 0,
      date: 0,
      days: []
    }
  },
  computed: {
    dateString() {
      if (!this.year || !this.month || !this.date) {
        return ''
      }

      const m = this.month < 10 ? `0${this.month}` : this.month
      const d = this.date < 10 ? `0${this.date}` : this.date

      return `${this.year}-${m}-${d}`
    }
  },
  methods: {
    init() {
      const [y, m, d] = this.value.split('-').map(n => n * 1)

      this.year = y || null
      this.month = m || null
      this.date = d || null

      this.updateDays()
    },
    updateDays() {
      if (this.year === '' || this.month === '') {
        return false
      }

      // 特定の年月の最後の日付を取得する
      const lastDay = (new Date(this.year, this.month, 0)).getDate()
      this.days = range(1, lastDay)

      // 最終日より大きい値が入っていたら1日にリセット
      // 値を維持できる場合はそのまま
      if (this.date * 1 > lastDay) {
        this.date = 1
      }
    },
    emit() {
      this.$emit('input', this.dateString)
    },
    onChange() {
      this.updateDays()
      this.emit()
    }
  },
  created() {
    this.init()
  }
}
</script>
